<script setup lang="ts">
import DirectusImage from './DirectusImage.vue';

const props = defineProps(['icon', 'value', 'max', 'disableLines', 'iconClass', 'limit']);

const positive: () => number = () => Math.max(0, Math.min(props.value / props.max, 1));
const amazing: () => number = () => Math.max(0, Math.min(props.value / props.max - 1, 1));

const dynamicBackground: () => string = () =>
  amazing() > 0 ? 'bg-bg-amazing' : positive() > 0 ? 'bg-bg-positive' : 'bg-bg-neutral';
</script>

<template>
  <div
    class="relative inline-flex h-24 w-24 cursor-pointer flex-wrap justify-center rounded-lg transition-all duration-200 hover:brightness-105 active:brightness-95"
    :class="dynamicBackground()"
  >
    <img src="/amazing.png" class="absolute top-2 left-2 h-4 w-4" v-if="amazing() > 0" />
    <template v-if="props?.icon?.length == 36">
      <directus-image
        :src="props.icon"
        class="h-20 w-20"
        :class="props.max ? 'mb-[-16px]' : 'mt-2'"
      />
    </template>
    <template v-else>
      <div class="mt-4 text-6xl" :class="props.iconClass">{{ props.icon }}</div>
    </template>
    <template v-if="props.max">
      <div
        class="bg-bg-empty border-border-empty relative h-4 w-20 overflow-hidden rounded-2xl border-2"
      >
        <div
          class="bg-fill-positive absolute top-0 left-0 h-4 transition-all duration-200"
          :style="{ width: positive() * 100 + '%' }"
        ></div>
        <div
          class="bg-fill-amazing absolute top-0 left-0 h-4 transition-all duration-200"
          :style="{ width: amazing() * 100 + '%' }"
        ></div>
        <div
          v-if="!props.disableLines"
          class="bg-border-empty absolute top-0 h-4 w-0.5"
          :style="{ left: (100 / props.max) * i + '%' }"
          v-for="i in props.max - 1"
        ></div>
      </div>
    </template>
    <template v-if="props.limit">
      <div
        class="font-fredoka absolute -top-2 -right-2 h-6 w-6 rounded-2xl text-center text-white"
        :class="dynamicBackground()"
      >
        {{ props.limit }}
      </div>
    </template>
    <slot />
  </div>
</template>

<style scoped></style>
